import { PlatformIcon, getPlatformColor, Delta } from '@/components/primitives';
import { formatCount, shortPlatform } from '@/lib/format';
import styles from './PlatformChip.module.css';

export interface PlatformChipProps {
  platform: string;
  subscribers: number;
  subscriberChange?: number;
  selected: boolean;
  onSelect: (platform: string) => void;
}

/**
 * Compact platform selector carrying a single streaming metric.
 *
 * One number only — subscribers. The fuller metric set lives on the Platforms
 * leaderboard; repeating it here just competes with the Top 10s below.
 */
export function PlatformChip({
  platform,
  subscribers,
  subscriberChange,
  selected,
  onSelect,
}: PlatformChipProps) {
  return (
    <button
      type="button"
      className={`${styles.chip} ${selected ? styles.selected : ''}`}
      onClick={() => onSelect(platform)}
      aria-pressed={selected}
      style={{ '--brand': getPlatformColor(platform) } as React.CSSProperties}
    >
      <span className={styles.wash} aria-hidden="true" />
      <PlatformIcon name={platform} size={26} className={styles.logo} />
      <span className={styles.text}>
        <span className={styles.name}>{shortPlatform(platform)}</span>
        <span className={styles.metric}>
          <span className={styles.subs}>{formatCount(subscribers)}</span>
          <span className={styles.subsLabel}>subs</span>
          {subscriberChange != null && <Delta value={subscriberChange} digits={2} />}
        </span>
      </span>
    </button>
  );
}
